export default [

     {
          path: '/control-class',
          name: 'ControlClass',
          component: () => import("@/views/Page/ControlClass/ControlClass.vue"),
           meta: {
               title: '#Default# | ControlClass',
          },
     }
];